import { RequiredProps } from '@procore/core-react/dist/_typedoc/Required/Required.types.json';
import * as React from 'react';
export default {
  RequiredProps,
  React
};